import { ControlPropertyType } from '../../../enums';
import { InputType } from '../../../shared/input/enums';

export const TextInputProperty = {
  ...ControlPropertyType,
  MinLength: 'min',
  MaxLength: 'max',
  TextType: 'textType',
  FillType: 'fillType',
  IsReadonly: 'isReadonly',
  IsLoading: 'isLoading',
};

export const TextInputType = {
  Text: InputType.Text,
  Email: InputType.Email,
  Telephone: InputType.Telephone,
  Password: InputType.Password,
};

export default {
  TextInputProperty,
};
